import * as React from "react";
import ConfigStyle from "./ConfigStyle";
import ConfigContext from "../context/ConfigContext";
import { EngagementConfiguration } from "../types";

const css = require("../css/velaro.css").toString();

interface DefaultHeadProps {
  config: EngagementConfiguration;
}

class DefaultHead extends React.Component<DefaultHeadProps, {}> {
  render() {
    return (
      <React.Fragment>
        <style type="text/css">{css}</style>
        <ConfigStyle />
      </React.Fragment>
    );
  }
}

export default () => (
  <ConfigContext.Consumer>
    {config => <DefaultHead config={config} />}
  </ConfigContext.Consumer>
);
